import Authorized from "./Authorized";
import check from "./CheckPermissions";
import Secured from "./Secured";

Authorized.Secured = Secured;
Authorized.check = check;

export default Authorized;
